import {useRef, useState} from "react";
import Sidebar from "./layouts/Sidebar";
import Main from "./layouts/Main";
import UKRibbon from "./layouts/UKRibbon";
import AppTitle from "./layouts/AppTitle";
import Breadcrumb from "./components/Breadcrumb";
import SplashScreen from "./SplashScreen";
import MapSearch from "./esri-components/MapSearch";
import MapGallery from "./esri-components/MapGallery";
import LegendCard from "./esri-components/LegendCard";
import OverlayLayer from "./OverlayLayer";
import Download from "./Download";
import {MAP_OPTIONS, ACTIVE_HIGHLIGHT_LINE_ID} from "./settings";
import {useEsriLoader} from "./useEsriLoader";
import {EsriProvider} from "./EsriContext";
import AppStateProvider from "./AppContext";
import SearchProvider from "./esri-components/SearchProvider";
import {HelpToaster} from "./components/HelpToaster";

const additionalModules = [
    {path: "esri/Graphic", name: "Graphic"},
    {path: "esri/layers/GraphicsLayer", name: "GraphicsLayer"},
    {path: "esri/identity/IdentityManager", name: "IdentityManager"},
    {path: "esri/tasks/Geoprocessor", name: "Geoprocessor"},
    {path: "esri/widgets/Spinner", name: "Spinner"},
    {path: "esri/Color", name: "Color"},
    {path: "esri/symbols/SimpleLineSymbol", name: "SimpleLineSymbol"},
    {path: "esri/symbols/SimpleFillSymbol", name: "SimpleFillSymbol"},
];

function App() {
    const [isOpen, setIsOpen] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const mapRef = useRef();
    const tableRef = useRef();
    const buttonRef = useRef();

    const {esriLoader, view} = useEsriLoader(
        mapRef,
        MAP_OPTIONS,
        additionalModules,
        ACTIVE_HIGHLIGHT_LINE_ID,
        tableRef,
        buttonRef
    );

    return (
        <EsriProvider esriLoader={esriLoader} view={view}>
            <AppStateProvider>
                <SearchProvider>
                    <div className="app overflow-hidden h-screen">
                        <SplashScreen isOpen={isOpen} setIsOpen={setIsOpen}/>
                        <div style={isOpen ? {display: "none"} : {}}>
                            <HelpToaster/>
                            <UKRibbon/>
                            <div className="flex flex-row container-height">
                                <Sidebar>
                                    <AppTitle/>
                                    <hr className="border-blue-700"/>
                                    <Breadcrumb
                                        back={<a href="/compliance-data">Data</a>}
                                        current={
                                            <a href="/data/compliance-map">Smoke Control Areas Map</a>
                                        }
                                    />
                                    <hr className="border-blue-700"/>
                                    <div className="px-3 pt-8">
                                        <OverlayLayer/>
                                        <Download/>
                                        <MapGallery/>
                                        <button
                                            onClick={() => {
                                                window.location.reload();
                                            }}
                                            className="bg-white w-full hover:bg-blue-400 border-blac text-black hover:border-blue-500 font-medium mt-3 py-2 px-4 rounded"
                                        >
                                            Reset Map Selections
                                        </button>
                                    </div>
                                </Sidebar>
                                <div className="flex flex-1 flex-col container-height">
                                    <Main>
                                        <MapSearch/>
                                        <div
                                            data-testid="webmap_canvas-test"
                                            className="webmap"
                                            ref={mapRef}
                                            style={{height: "100%"}}
                                        />
                                        <LegendCard
                                            position="bottom-0 left-0"
                                            customClass="h-auto w-auto"
                                        />
                                        <div className="esri-expand__container">
                                            <div className="esri-expand__panel">
                                                <a ref={buttonRef}
                                                   href="#tableDiv"
                                                   aria-label={showTable ? "Hide data table" : "Show and skip to data table"}
                                                   className="esri-widget--button top-0 right-0"
                                                   onClick={() => setShowTable(!showTable)}>
                                                    <span className="esri-collapse_icon esri-icon-table"></span>

                                                </a>
                                            </div>
                                        </div>
                                    </Main>
                                    <div
                                        id="tableDiv"
                                        ref={tableRef}
                                        aria-label="Data Table"
                                        className="tableContainer"
                                        style={showTable ? {} : {display: "none"}}
                                    >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SearchProvider>
            </AppStateProvider>
        </EsriProvider>
    );
}

export default App;
